// axios
import axios from 'axios'

export default axios.create({
  headers: {
    'x-ubun': 'tokyo'
  }
})
